// extracted by mini-css-extract-plugin
export default {"imageContainer":"Sca-z","summaryPar":"Tca-z","ratingCategories":"Uca-z","reviewerInfo":"Vca-z","reviewTypes":"Wca-z","expanded":"Xca-z"};